import React, { useState,useEffect , useContext} from 'react';
import './receipt.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSearch, faRefresh, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'
import TopBar from '../../components/topbar'
import moment from 'moment'
import Logo from '../../assets/logo.png';

function Receipt() {
    const navigate = useNavigate();
    const { profile } = useContext(ShareContext);

    const {refid} = useParams();
    const url= `${Constants.apiUrl}/gazette/paymentreceipt/${refid}`;
    const [pay, setPay] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const onLoad= async()=>{
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
          
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setPay(data.pay);
               
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    useEffect(() => {     
        onLoad();
        
     
  }, [profile])

  return (
    <div className='receipt'>

        <div className="body">
      
            <div className="container">
                <div><img src={Logo} style={{width:150}} alt='JIS Logo' /></div>
                <h3 className='success'>Your Payment Receipt</h3>
                <div className="details">
                    <div className="head">
                        <h3>Receipt Details</h3>
                    </div>
                    <div className="row">
                        <p className="title">Reference No</p>
                        <p className="answer">{refid}</p>
                    </div>
                    <div className="row">
                        <p className="title">Payer Name</p>
                        <p className="answer">{pay.name} </p>
                    </div>
                   
                    <div className="row">
                        <p className="title">Date and Time of Transaction</p>
                        <p className="answer">{moment(pay.dateCreated).format("dddd, MMMM Do YYYY, h:mm a") }</p>
                    </div>
                   
                    <div className="row">
                        <p className="title">Payment Details</p>
                        <p className="answer">Success</p>
                    </div>
                    <div className="row">
                        <p className="title">Payment Type</p>
                        <p className="answer">{pay?.type==5?'Affidavit':'Document Search'}</p>
                    </div>
                   
                   
                    <div className="row">
                        <p className="title">Amount</p>
                        <p className="answer">{Constants.formatCurrency(pay?.amount) }</p>
                    </div>
                    <div className="row">
                        <p className="title">Note</p>
                        <p className="answer">{pay?.note}</p>
                    </div>
                </div>
            </div>
            <div className="down">
               
                <div className="btns">
                    <button className="black no-print" style={{marginLeft:16}} onClick={()=> window.print()}>Print</button>
                    
                </div>
            </div>
        </div>
        <BackLoader open={isLoading}  />
    </div>
  )
}

export default Receipt